import React, { ReactNode, useState } from "react";

import { TooltipContentType } from "components/gt-tooltip/gt-tooltip";
import CustomButton from "components/custom-button/custom-button";
import { useMountTransition } from "hooks/useMountTransition";
import hasPermission from "utils/hasPermissions";

interface IModalWrapper {
    permCode?: string;
    text?: string;
    icon?: string | { name: string | string[] };
    render?: any;
    disabled?: boolean;
    className?: string;
    color?: string;
    tooltipContent?: TooltipContentType;
    reqModal?: boolean;
    display?: boolean;
    children?: (modalOpen: boolean, closeModal: () => void) => ReactNode;
}

export const ModalWrapper = ({
    text,
    icon,
    permCode,
    disabled,
    render: ModalContent,
    className = "",
    color,
    tooltipContent,
    reqModal,
    display = true,
    children,
}: IModalWrapper) => {
    const [modalOpen, setModalOpen] = useState<boolean>(false);

    const hasTransitionedIn = useMountTransition(modalOpen);
    return (
        <>
            <CustomButton
                text={text}
                icon={icon}
                onClick={() => setModalOpen(true)}
                permCode={permCode}
                disabled={disabled}
                withoutPerm={!permCode}
                className={className}
                color={color}
                tooltipContent={tooltipContent}
                reqModal={reqModal}
                display={display}
            />
            {(modalOpen || hasTransitionedIn) && children && children(modalOpen, () => setModalOpen(false))}
        </>
    );
};

interface IStatelessModalWrapper {
    modalOpen: boolean;
    children: ReactNode;
    permCode?: string;
}

export const StatelessModalWrapper = ({ children, modalOpen, permCode }: IStatelessModalWrapper) => {
    if (typeof permCode === "string" && !hasPermission(permCode)) return <></>;

    const hasTransitionedIn = useMountTransition(modalOpen);

    return <> {(modalOpen || hasTransitionedIn) && children}</>;
};
